import styled from 'styled-components';

export const Container = styled.nav``;

export const List = styled.ul`
  width: 100%;
  max-width: 30rem;
`;
